export const headers = [
  { name: 'Módulo', field: 'paymentModule.name', sortable: true },
  { name: 'Tipo', field: 'type', sortable: false },
  { name: 'Ações', field: 'actions', sortable: false }
]
